module.exports = __webpack_public_path__ + "media/images/etiqa_card-71b31252fd27481f98482549b3ae753e.png";